export const HomeUrls: { [key: string]: string } = {
    'pasajes.busesaltascumbres.cl': 'https://www.busesaltascumbres.cl',
    'pasajes.busespullmantur.cl': 'https://home.busespullmantur.cl',
    'pasajes.narbus.cl': 'https://www.narbus.cl'
}
